import React from 'react';

import clsx from 'clsx';

import GLOBALS from 'app-globals';
import { Button, Card, Heading, Icon, Text } from 'components';
import { BUTTON_VARIANTS } from 'components/Button/constants';
import { HEADING_SIZES } from 'components/Heading/constants';

import * as styles from './styles.module.scss';

function FeatureCard({
  description,
  image,
  number,
  heading,
  subheading,
  tag,
  onLearnMore,
}) {
  const numberJsx = (
    <Heading
      colorClass={GLOBALS.COLOR_CLASSES.NEUTRAL['0']}
      size={HEADING_SIZES.XXS}
    >
      {number}
    </Heading>
  );

  return (
    <div className={styles.container}>
      <div className={styles.line} />
      <div className={styles.number___desktop}>{numberJsx}</div>
      <Card className={styles.card}>
        <div className={styles.content}>
          <div className={styles.main}>
            <div className={styles.number___mobile}>{numberJsx}</div>
            <div className={styles.info}>
              <span
                className={clsx(styles.tag, {
                  [styles.tag___before]: tag.includes('Before'),
                  [styles.tag___during]: tag.includes('During'),
                  [styles.tag___after]: tag.includes('end'),
                })}
              >
                {tag}
              </span>
              <div className={styles.text}>
                <Heading className={styles.heading} size={HEADING_SIZES.XXXS}>
                  {heading}
                  {subheading && (
                    <span className={styles.subheading}> {subheading}</span>
                  )}
                </Heading>
                <Text
                  className={styles.description}
                  colorClass={GLOBALS.COLOR_CLASSES.NEUTRAL['500']}
                >
                  {description}
                </Text>
              </div>
              {onLearnMore && (
                <button
                  className={styles.button___desktop}
                  type="button"
                  onClick={onLearnMore}
                >
                  Learn more
                  <Icon name="launch" />
                </button>
              )}
            </div>
          </div>
          {image}
          {onLearnMore && (
            <Button
              className={styles.button___mobile}
              rightIcon={<Icon name="launch" />}
              variant={BUTTON_VARIANTS.OUTLINE}
              onClick={onLearnMore}
            >
              Learn more
            </Button>
          )}
        </div>
      </Card>
    </div>
  );
}

export default FeatureCard;
